import type { StreamChat } from 'stream-chat';

export async function ensureStreamUserConnected(client: StreamChat, userId: string, token: string) {
    const normalizedUserId = userId.trim();
    if (!normalizedUserId || !token) {
        return;
    }
    if (client.userID === normalizedUserId) {
        return;
    }
    if (client.userID && client.userID !== normalizedUserId) {
        await client.disconnectUser();
    }
    await client.connectUser({ id: normalizedUserId }, token);
}
